<template>
	<div class="board-cell">
		<div class="circle"></div>
	</div>
</template>

<script>
export default {
	props: ["cols", "rows", "x", "y"]
};
</script>

<style lang="scss">
@import "@/scss/variables.scss";
@import "@/scss/sizing.scss";

.board-cell {
	@include cell-size();
	border: 1px solid transparent;
	margin: -1px 0 0 -1px; // -1px is a workaround to double borders
	position: relative;

	.bordered & {
		border: 1px solid $border-color;

		// since we decrease alpha below 1
		// borders on top of each other (see margin -1px)
		// will sum up, so we need to hide them
		&:not(:nth-child(1)) {
			border-left-color: transparent;
		}

		.board-row:not(:nth-child(1)) & {
			border-top-color: transparent;
		}
	}

	.circle {
		border: 1px solid $border-color;
		border-radius: 50%;
		bottom: 0;
		left: 0;
		position: absolute;
		right: 0;
		top: 0;
	}
}
</style>
